import colorsMixin from './colors'
import {relationLabel} from '../plugins/filters'
import DetailsTable from '../components/fields/DetailsTable.vue'
// import { normalizeApiData, transformLinkTableArray } from '../utils/oData'

export default {
  mixins: [colorsMixin],

  props: {
    value: {
      type: [Object, Array]
    },
    addButton: {
      type: Boolean,
      default: () => true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showBrowse: {
      type: Boolean,
      default: true
    },
    allowEdit: {
      type: Boolean,
      default: true
    },
    column: {
      type: Object,
      required: true
    },
    resource: {
      type: String,
      default: () => null
    },
    isFilter: {
      type: Boolean,
      default: () => false
    },
    template: {
      type: String,
      default: () => 'form'
    },
    parentId: {
      type: [Number, String],
      default: () => null
    },
    filter: {
      type: Object,
      default: () => null
    },
    compare: {
      type: Boolean,
      default: () => false
    },
    compareId: {
      type: Number,
      default: () => 0
    }
    // compareObj: {
    //   type: [Object, Array, String],
    //   default: () => {}
    // }
  },

  components: {
    DetailsTable
  },

  data () {
    return {
      showOptions: false,
      searching: false,
      loaded: true,
      loading: false,
      term: '',
      modalOpen: false,
      modalData: null,
      infoModalOpen: false,
      newFormModalOpen: false,
      newFormModalIndex: false,
      editFormModalOpen: false,
      editFormModelId: null,
      providedModel: false,
      editing: false,
      pagination: { page: 1, rowsPerPage: 15, rowsNumber: 1 },
      options: []
    }
  },

  computed: {
    relation () {
      return this.column.relation
    },
    relationType () {
      return this.relation ? this.relation.type : null
    },
    relationResource () {
      return this.relation ? this.relation.namespace : null
    },
    parentResource () {
      return this.$route.meta.resource
    },
    apiUrl () {
      return this.relationResource ? this.$store.state[this.relationResource].apiEndpoint : ''
    },
    hasValue () {
      return (this.relationType === 'one' && !!this.value) || (this.relationType === 'many' && !!this.value && this.value.length)
    },
    editModeActive () {
      return this.editing || !this.hasValue
    },
    titleColumn () {
      return this.relationResource && this.$store.state[`${this.relationResource}`] ? this.$store.getters[`${this.relationResource}/titleColumn`] : undefined
    },
    subtitleColumn () {
      return this.relationResource && this.$store.state[`${this.relationResource}`] ? this.$store.getters[`${this.relationResource}/subtitleColumn`] : undefined
    },
    infoColumns () {
      return this.relationResource && this.$store.state[`${this.relationResource}`] ? this.$store.getters[`${this.relationResource}/infoColumns`] : []
    },
    relationColumns () {
      const arr = []
      if (this.titleColumn && typeof this.titleColumn === 'object') {
        arr.push(this.titleColumn)
      }
      if (this.subtitleColumn && typeof this.subtitleColumn === 'object') {
        arr.push(this.subtitleColumn)
      }
      if (this.infoColumns && Array.isArray(this.infoColumns) && this.infoColumns.length) {
        const infoColumns = this.infoColumns.filter(c => c && typeof c === 'object' && c !== undefined)
        if (infoColumns.length) {
          infoColumns.forEach(c => {
            arr.push(c)
          })
        }
      }
      return arr
    },
    relationParentColumnMap () {
      return this.relationColumns
        .filter(c => c && typeof c === 'object' && c.field && c.relation && c.relation.namespace)
        .reduce((obj, relationColumn) => {
          const ns = relationColumn.relation.namespace
          const titleColumn = this.$store.getters[`${ns}/titleColumn`]
          if (titleColumn && relationColumn.field) {
            obj[relationColumn.field] = titleColumn
          }
          return obj
        }, {})
    },
    maxPage () {
      return Math.ceil(this.pagination.rowsNumber / this.pagination.rowsPerPage || 1)
    }
  },

  methods: {
    handleEditButton (editFormModelId) {
      this.$set(this, 'editFormModelId', editFormModelId)
      this.$set(this, 'editFormModalOpen', true)
    },
    handleEditRequest ({ index, model }) {
      if (model.id) {
        this.handleEditButton(model.id)
      } else {
        this.providedModel = model
        this.newFormModalOpen = true
        this.newFormModalIndex = index
      }
    },
    handleEdit (model, id, stay) {
      // console.log('relationFields handleEdit model: ', model, 'id: ', id, 'stay: ', stay)
      this.$q.notify({
        message: `Updated ${this.column.label}`,
        type: 'positive'
      })
      this.selected(model)
      const stayBool = !!stay
      if (!stayBool) {
        this.$set(this, 'editFormModalOpen', false)
      }
    },
    handleClose () {
      this.$set(this, 'view', 'default')
      this.$set(this, 'modalOpen', false)
    },
    handleClick (index) {
      const modalData = this.value[index]
      this.$set(this, 'modalData', modalData)
      this.$set(this, 'modalOpen', true)
    },
    mapOptions (options) {
      return options.map(obj => {
        return {
          label: relationLabel(obj, this.titleColumn, this.relationParentColumnMap[this.titleColumn.field]),
          subtitle: this.subtitleColumn ? relationLabel(obj, this.subtitleColumn, this.relationParentColumnMap[this.subtitleColumn.field]) : null,
          value: obj.id,
          id: obj.id,
          model: obj
        }
      })
    },
    exists (obj) {
      if (!obj || !obj.id) {
        return false
      }
      if (this.column.relation.type === 'one') {
        return !!(this.value && this.value.id && obj.value === this.value.id)
      }
      if (obj.value && obj.label) {
        return this.value.some(current => current.id === obj.value)
      }
      return this.value.some(current => current.id === obj.id)
    },
    handleNew (model, id, stay) {
      // console.log('relationFields handleNew model: ', model, 'id: ', id, 'stay: ', stay)
      this.$q.notify({
        message: `Added new ${this.column.label}`,
        type: 'positive'
      })
      this.selected(model)
      const stayBool = !!stay
      // console.log('stayBool', stayBool)
      if (!stayBool) {
        // console.log('close modal')
        this.$set(this, 'newFormModalOpen', false)
      }
    },
    async handleBrowseData () {
      const v = !this.showOptions
      if (v) {
        await this.fetchOptions({ pagination: this.pagination })
      }
      this.showOptions = v
    },
    async search (terms, done) {
      // console.log('terms', terms)
      // ODATA SAMPLE: http://host/service/Products?$search=blue OR green
      // const { data } = await this.$axios.get(`/api/odata/${this.relationResource}`, {
      //   params: {
      //     $top: 15,
      //     $search: terms.split(' ').join(' OR ')
      //     // $filter: `contains(firstName,'${terms}')`
      //   }
      // })
      // this.searching = false
      // // console.log(data)
      // if (data && data.value) {
      //   const mappedOptions = this.mapOptions(data.value)
      //   done(mappedOptions)
      // }
      let filter = 'removalDate eq null AND guestData ne true AND approved eq true'
      if (this.relationResource !== 'company' && this.relationResource !== 'person') {
        filter = 'removalDate eq null'
      }
      // console.log('this.relationResource', this.relationResource)
      // PETA POCO:
      const data = await this.$store.dispatch(`${this.relationResource}/search`, {
        client: this.$axios,
        search: terms,
        config: {
          params: {
            limit: 25,
            search: terms,
            $filter: filter
          }
        }
      })
      this.searching = false
      // console.log(data)
      if (data && data.data) {
        const mappedOptions = this.mapOptions(data.data)
        done(mappedOptions)
      }
      done([])
    },
    async handlePageChange (page) {
      await this.fetchOptions({ pagination: { page } })
    },
    async fetchOptions ({ pagination = { page: 1, rowsNumber: 1, rowsPerPage: 15 } }) {
      /*
      if (this.filter && (this.filter.path || this.filter.key) && this.filter.value) {
        let filterValue = null
        if (typeof this.filter.value === 'function') {
          try {
            filterValue = this.filter.value.call(this, this)
            // console.log('> Props: filter > value > (this) = ', filterValue)
            if (filterValue !== null && filterValue !== undefined) {
              shvl.set(config.params.filter, this.filter.path || this.filter.key, filterValue)
            }
          } catch (e) {
            this.$handleError(e)
          }
        }
      }
      */
      let config = {}
      // if (this.relation.parentRestraint && this.parentId) {
      //   config = {
      //     params: {
      //       $filter: `${this.relation.fk} eq ${this.parentId}`
      //     }
      //   }
      // }
      if (!pagination.page) {
        pagination.page = 1
      }
      if (!pagination.rowsNumber) {
        pagination.rowsNumber = 1
      }
      if (!pagination.rowsPerPage) {
        pagination.rowsPerPage = 15
      }
      this.loading = true
      // console.log('pagination', pagination)
      const data = await this.$store.dispatch(`${this.relationResource}/paginate`, {
        client: this.$axios,
        noFilters: true,
        noTransform: true,
        config,
        pagination
      })
      if (data) {
        // console.log('data', data)
        this.$set(this, 'pagination', {
          page: data.page,
          rowsPerPage: data.rowsPerPage,
          rowsNumber: data.rowsNumber
          // page: data.from,
          // rowsPerPage: data.perPage,
          // rowsNumber: data.total
        })
        this.$set(this, 'options', data.data)
      }
      this.loading = false
    },
    async addParent (model) {
      // console.log('addParent', model, 'this.value', this.value)
      if (Array.isArray(this.value)) {
        const parentModel = await this.fetchParent('csiCodes', model.parentId)
        // console.log('parentModel', parentModel)
        const newArray = this.value.slice(0)
        // console.log('newArray', newArray)
        let valueIndex = -1
        if (parentModel.id) {
          valueIndex = newArray.findIndex(na => na.id === parentModel.id)
          // console.log('parent valueIndex id found', valueIndex)
        } else if (this.newFormModalIndex >= 0 && this.newFormModalIndex !== false) {
          valueIndex = this.newFormModalIndex
        }
        // console.log('parent valueIndex', valueIndex)
        if (valueIndex >= 0) {
          // newArray[valueIndex] = parentModel
        } else {
          newArray.push(parentModel)
        }
        this.$emit('manual-update', this.column.field, newArray)
      }
      // const newOptionsParent = Array.isArray(this.value) ? this.value.slice(0) : []
      // newOptionsParent.push(parentModel)
      // console.log('newOptionsParent', newOptionsParent)

      // this.$emit('manual-update', this.column.field, newOptionsParent)
    },
    async selected (obj, close = true) {
      // console.log('>> selected')
      // console.log('selected obj', obj)
      // console.log('this.column', this.column)
      const model = obj.model || obj
      // -- handle type ONE
      if (this.column.relation.type === 'one') {
        this.$emit('manual-update', this.column.field, model)
      } else {
        // console.log('model', model)
        // if (this.exists(model)) {
        //   // console.log('exists', model)
        // }
        if (Array.isArray(this.value)) {
          if (this.column && this.column.field && this.column.field === 'companyCsiCodes') {
            // console.log('index', index, 'model', model, 'this.value', this.value)
            if (model && model.parentId) {
              await this.addParent(model)
            }
          }
          const newArray = this.value.slice(0)
          let valueIndex = -1
          // console.log('this.newFormModalIndex', this.newFormModalIndex)
          // console.log('model.id', model.id)
          if (model.id) {
            valueIndex = newArray.findIndex(na => na.id === model.id)
          } else if (this.newFormModalIndex >= 0 && this.newFormModalIndex !== false) {
            valueIndex = this.newFormModalIndex
          }
          // console.log('newArray 1', newArray)
          // console.log('valueIndex', valueIndex)
          if (valueIndex >= 0) {
            newArray[valueIndex] = model
          } else {
            newArray.push(model)
          }
          // console.log('newArray 2', newArray)
          // console.log('selected model', model)
          this.$emit('manual-update', this.column.field, newArray)
          this.newFormModalIndex = false
          this.providedModel = false
          // this is where it goes wrong...
        } else {
          // console.log('[model]', [model])
          this.$emit('manual-update', this.column.field, [model])
        }
        const optionIndex = this.options.findIndex(o => o.id === model.id)
        // console.log('optionIndex', optionIndex, this.options, model)
        if (optionIndex !== -1) {
          this.$delete(this.options, optionIndex)
        }
        /* this.$emit('add', this.column.field, model)
        this.$nextTick(() => {
          this.$emit('sync')
        }) */
      }
      this.$set(this, 'editing', false)
      this.$set(this, 'term', '')
      if (close) {
        this.$set(this, 'showOptions', false)
      }
    },
    async fetchParent (resource, id) {
      const model = await this.$store.dispatch(`${resource}/fetchOne`, {client: this.$axios, id: id, noFilters: true})
      // console.log('fetchData model', model)
      return model
      // this.$nextTick(() => {
      //   this.loaded = true
      // })
    },
  },

  mounted () {
    // this.fetchOptions({pagination: this.pagination})
  },

  created () {
    if (this.value) {
      if (Array.isArray(this.value)) {
        return this.options.concat(this.value)
      }
      if (typeof this.value === 'object') {
        this.options.push(this.value)
      }
    }
  }
}
